import AddMultipleMemberDropDownNew from "components/AddMultipleMemberDropDownNew/AddMultipleMemberDropDownNew";
import InfoTooltip from "components/Tooltip/InfoTooltip";
import DocumentUploadSection from "custom_modules/JobComponents/DocumentUploadSection";
import JobInputSection from "custom_modules/JobComponents/JobInputSection";
import JobStartTimeSection from "custom_modules/JobComponents/JobStartTimeSection";
import LineItemSection from "custom_modules/JobComponents/LineItemSection";
import RecurringScheduleSection from "custom_modules/JobComponents/RecurringScheduleSection";
import SubtaskSection from "custom_modules/JobComponents/SubtaskSection";
import { ExpandIcon } from "custom_modules/Projects/projectsStyles";
import ClientModal from "custom_modules/WorkOrderNew/CreateWorkOrder/ClientModal";
import moment from "moment-timezone";
import react, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";
import styled from "styled-components";

import arrowWhiteIcon from "../../../assets/img/icons/arrow_right_white.svg";
import durationIcon from "../../../assets/img/icons/clock-in-duration.svg";
import crossIcon from "../../../assets/img/icons/cross_black.svg";
import deleteIcon from "../../../assets/img/icons/delete-3.svg";
import Plus from "../../../assets/img/icons/plus_primary.svg";
import PlusWhite from "../../../assets/img/icons/plus_white.svg";
import tickWhite from "../../../assets/img/icons/tick_2.svg";
import tick from "../../../assets/img/onboardingImg/tick-black.svg";
import AddOrgLocationModal from "../../../components/AddOrgLocationModal/AddOrgLocationModal";
import AddMultipleAssigneeDropdown from "../../../components/CustomDropdown/AddMultipleAssigneeDropdown";
import { CommonCardContainer } from "../../../components/DashboardCards/cardStyles";
import CreateProjectDropdown from "../../../components/DropdownStyle/CreateProjectDropdown";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import Select from "../../../components/ReactSelectDropdown";
import { filterOption } from "../../../components/ReactSelectDropdown/ReactSelectDropdown";
import RoundTab from "../../../components/RoundTabButtons/RoundTab";
import DatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import SingleDatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import {
  CardsContainer,
  HorizontalLineDivider,
} from "../../../styledComponents/Activity";
import {
  BorderButtonWithIcon,
  ButtonIcon,
  ColoredButtonWithIcon,
  PrimaryButton,
  RadiusButton,
  WhiteButton,
} from "../../../styledComponents/buttons";
import {
  TabButton,
  TabButtonContainer,
} from "../../../styledComponents/buttons";
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
  ContentHeader,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  InputWithLabelSection,
  ModalCrossIcon,
  PageTitle,
  RedStar,
} from "../../../styledComponents/common";
import { CrossIcon } from "../../../styledComponents/createProject";
import { RadioButton } from "../../../styledComponents/members";
import {
  CheckboxDiv,
  CheckboxTickIcon,
} from "../../../styledComponents/settings";
import { formatDurationToHoursMinutes } from "../../../utils/helper";
import { checkHtml, checkUrl } from "../../../utils/helper";
import AddLocationModal from "../../ClientsNew/ClientDetails/AddLocationModal";
import AddSubTaskModal from "../../Jobs/CreateJob/AddSubTaskModal";
import EditSubTaskModal from "../../Jobs/CreateJob/EditSubTaskModal";
import SingleLocationMap from "../../Jobs/CreateJob/SingleLocationMap";
import SubTaskTable from "../../Jobs/CreateJob/SubTaskTable";
import {
  AssigneeSection,
  InputSection,
  SubTaskTableHeaderContainer,
  SubTaskTableRowContainer,
  TimeRangeSection,
} from "../../Jobs/CreateJob/createTaskStyles";
import {
  AdditionalOptionText,
  CheckCircle,
  DurationContainer,
  DurationText,
  EditTypeButton,
  MonthDateBox,
  MonthDateContainer,
  RepeatSection,
  ScheduleText,
  ThemeBox,
  ThemesContainer,
  TickIcon,
  WeekDaysContainer,
  WeekNumberBox,
  WeekdayBox,
} from "../../ShiftSchedule/CreateShift/createShiftStyles";
import TimeRangeComponent from "../../Timesheet/Daily/TimeRangeComponent";
// import { zIndex } from "html2canvas/dist/types/css/property-descriptors/z-index";

const SHORT_WEEK_DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const FULL_WEEK_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const EditJobPopup = ({
  selectedOrganization,
  isLoading,
  orgMembersShortList,
  addTaskLocationLoading,
  locationsList,
  createdTaskLocationInfo,
  memberShortListIsLoading,
  getOrganizationMembersShortList,
  taskTypeList,
  history,
  location,

  //workorder short
  getWorkOrderShortList,
  workOrderShortList,

  // customer location
  clientLocationList,
  getclientLocalMapLoading,
  addOrUpdateclientLocalMapLoading,
  createdClientLocationInfo,

  getClientLocation,
  addClientLocation,
  updateClientLocation,

  // client short list
  clientShortList,
  getClientShortList,
  // client
  createClient,
  isClientLoading,
  createdClientId,
  createdClientInfo,

  // organization location
  organizationLocationList,
  getOrganizationLocationLoading,
  addOrgLocationLoading,
  createdOrgLocationInfo,
  getOrganizationLocations,
  createOrgLocation,

  // job
  jobDetails,
  getJobIsLoading,
  updateJobRequest,
  updatedJob,
  createOrUpdateJobIsLoading,
  jobUpdate,

  isOpen,
  toggle,
  onUpdateChange,
  selectedJob,

  getJobDetails,
  getTaskType,
  getTaskLocation,
  addTaskLocation,

  setIsRecurringDisabled,
  pricingPopupToggle,
  setPricingPopup,
  // subtasks
  subtasks,
  subtaskCreated,
  subtaskUpdated,
  subtaskDeleted,
  resetSubtaskStatus,
  getSubtasks,
  createSubtask,
  updateSubtask,
  deleteSubtask,
  // job documents
  getJobDocuments,
  createJobDocument,
  deleteJobDocument,
  jobDocuments,
  documentLoading,
  documentDone,
  documentError,
}) => {
  const { t, i18n } = useTranslation();

  const orgTimezone = selectedOrganization?.timezone || moment.tz.guess();
  const MONTH_TOTAL_DAYS = 31;
  const MONTH_GRID_COLUMNS = 7;
  const LAST_DAY_SPAN_COLUMNS =
    (MONTH_GRID_COLUMNS - (MONTH_TOTAL_DAYS % MONTH_GRID_COLUMNS)) %
      MONTH_GRID_COLUMNS || MONTH_GRID_COLUMNS;

  // Dynamic labels and paths based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  // Disable recurring schedule editing if job is already recurring
  const isRecurringDisabled = jobDetails?.recurring === true;
  const addItemDetailsLabel = isOperationType
    ? t("edit_task_details")
    : t("edit_job_details");
  const itemNameLabel = isOperationType ? t("task_name") : t("job_name");
  const typeItemNameLabel = isOperationType
    ? t("type_task_name")
    : t("type_job_name");
  const itemStartDateLabel = isOperationType
    ? t("task_start_date")
    : t("job_start_date");
  const itemDurationLabel = isOperationType
    ? t("task_duration")
    : t("job_duration");
  const workOrderLabel = isOperationType ? t("project") : t("job");
  const selectWorkOrderLabel = isOperationType
    ? t("select_project")
    : t("select_job");
  const jobNoLabel = isOperationType ? t("task_no") : t("job_no");

  const [jobName, setJobName] = useState("");
  const [jobNumber, setJobNumber] = useState("");
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [requiresApproval, setRequiresApproval] = useState(false);
  const [taskDescription, setTaskDescription] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [jobLocationOptions, setJobLocationOptions] = useState([]);
  const [startDate, setStartDate] = useState(moment(new Date()));
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [selectedScheduleForType, setSelectedScheduleForType] = useState("now");
  const [interval, setInterval] = useState(1);
  const [activeDays, setActiveDays] = useState({
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  });
  const weekParse = {
    monday: 0,
    tuesday: 1,
    wednesday: 2,
    thursday: 3,
    friday: 4,
    saturday: 5,
    sunday: 6,
  };
  const [isWeekViewOfMonth, setIsWeekViewOfMonth] = useState(false);
  const [activeMonthDates, setActiveMonthDates] = useState({});
  const [activeMonthDays, setActiveMonthDays] = useState({});
  const [scheduleDescription, setScheduleDescription] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [selectedJobStatus, setSelectedJobStatus] = useState({});
  const [popupOpen, setPopupOpen] = useState(false);

  const [saveErrors, setSaveErrors] = useState({});
  const radiusOptions = [20, 50, 100];
  const [statusOptions, setStatusOptions] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [workOrderOptions, setWorkOrderOptions] = useState([]);
  const [clientId, setClientId] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);

  const [addLocationButton, setAddLocationButton] = useState(false);
  const [themeColor, setThemeColor] = useState("");
  const [isSubTaskModalOpen, setIsSubTaskModalOpen] = useState(false);
  const [isEditSubTaskModalOpen, setIsEditSubTaskModalOpen] = useState(false);
  const [subTaskList, setSubTaskList] = useState([]);
  const [selectedSubTaskId, setSelectedSubTaskId] = useState(null);
  const [isAnyTimeSet, setIsAnyTimeSet] = useState(false);
  const [isRecurringScheduleOpen, setIsRecurringScheduleOpen] = useState(false);
  const [selectedRecurringSchedule, setSelectedRecurringSchedule] =
    useState("daily");
  const [selectedRecurringScheduleDays, setSelectedRecurringScheduleDays] =
    useState([]);
  const [monthlyScheduleMode, setMonthlyScheduleMode] = useState("dates"); // "dates" | "days"

  const [lineItems, setLineItems] = useState([]);
  const [documents, setDocuments] = useState([]);
  // Store IDs from jobDetails to select after lists are loaded
  const [pendingClientId, setPendingClientId] = useState(null);
  const [pendingLocationId, setPendingLocationId] = useState(null);

  const jobInputRef = useRef(null);
  const scrollName = useRef(null);
  const scrollDescription = useRef(null);
  const scrollTime = useRef(null);
  const prevJobDetailsIdRef = useRef(null);
  const prevClientLocationListRef = useRef(null);
  const lineItemsInitializedRef = useRef(false);
  const prevSubtasksRef = useRef(null);
  const prevJobDocumentsRef = useRef(null);
  const prevDocumentDoneRef = useRef(false);
  const [editType, setEditType] = useState("single");

  const openEditSubTaskModal = subTaskId => {
    setSelectedSubTaskId(subTaskId);
    setIsEditSubTaskModalOpen(true);
  };

  const closeEditSubTaskModal = () => {
    setIsEditSubTaskModalOpen(false);
    setSelectedSubTaskId(null);
  };

  const handleDeleteSubtask = subtaskId => {
    if (
      orgType === "operation" &&
      selectedOrganization?.id &&
      jobDetails?.work_order?.id &&
      jobDetails?.id &&
      subtaskId
    ) {
      deleteSubtask({
        organization_id: selectedOrganization.id,
        work_order_id: jobDetails.work_order.id,
        job_id: jobDetails.id,
        subtask_id: subtaskId,
        orgType: orgType,
      });
    }
  };

  const DEFAULT_LOCATION_RADIUS = 100;
  const buildLocationOption = location => {
    if (!location) {
      return null;
    }
    return {
      value: location.id,
      label: location.name,
      latitude: location.latitude,
      longitude: location.longitude,
      radius:
        location.radius !== undefined && location.radius !== null
          ? location.radius
          : DEFAULT_LOCATION_RADIUS,
      address: location.address,
      is_default:
        location.is_default !== undefined && location.is_default !== null
          ? location.is_default
          : location.default || false,
      client: location.client,
    };
  };

  const updateSelectedLocationState = option => {
    // Note: In edit mode, work order is already set, but we still allow location selection
    if (option) {
      setSelectedLocation(option);
      // Only set customer name for service type
      if (orgType !== "operation") {
        setCustomerName(prevName => option.client?.name || prevName || "");
      }
    } else {
      setSelectedLocation(null);
      // Only clear customer name for service type
      if (orgType !== "operation") {
        setCustomerName("");
      }
    }
  };

  const clientOptions = useMemo(() => {
    if (!clientShortList || clientShortList.length === 0) return [];
    return clientShortList
      .map(client => ({
        value: client.id,
        label: client.name,
      }))
      .filter(opt => opt.value && opt.label);
  }, [clientShortList]);

  const toggleClientModal = () => {
    setIsClientModalOpen(prev => !prev);
  };

  const handleClientChange = option => {
    let errors = { ...saveErrors };
    delete errors["selectedClient"];
    setSaveErrors(errors);

    setSelectedClient(option || null);
    setClientId(option?.value || "");
    setCustomerName(option?.label || "");

    // Switching customer should reset dependent selections for service
    if (orgType === "service") {
      setSelectedLocation(null);
      setJobLocationOptions([]);
    }
  };

  // Line item callbacks for service edit mode
  const handleAddLineItem = itemPayload => {
    if (
      orgType !== "operation" &&
      selectedOrganization?.id &&
      jobDetails?.work_order?.id &&
      jobDetails?.id
    ) {
      createSubtask({
        organization_id: selectedOrganization.id,
        work_order_id: jobDetails.work_order.id,
        job_id: jobDetails.id,
        data: itemPayload,
        orgType: orgType,
      });
    }
  };

  const handleUpdateLineItem = itemPayload => {
    if (
      orgType !== "operation" &&
      selectedOrganization?.id &&
      jobDetails?.work_order?.id &&
      jobDetails?.id &&
      itemPayload?.id
    ) {
      updateSubtask({
        organization_id: selectedOrganization.id,
        work_order_id: jobDetails.work_order.id,
        job_id: jobDetails.id,
        subtask_id: itemPayload.id,
        data: itemPayload,
        orgType: orgType,
      });
    }
  };

  const handleDeleteLineItem = itemPayload => {
    if (
      orgType !== "operation" &&
      selectedOrganization?.id &&
      jobDetails?.work_order?.id &&
      jobDetails?.id &&
      itemPayload?.id
    ) {
      deleteSubtask({
        organization_id: selectedOrganization.id,
        work_order_id: jobDetails.work_order.id,
        job_id: jobDetails.id,
        subtask_id: itemPayload.id,
        orgType: orgType,
      });
    }
  };

  const weekDays = SHORT_WEEK_DAYS;
  const daysOfWeek = FULL_WEEK_DAYS;
  const dateText = {
    1: "1st",
    2: "2nd",
    3: "3rd",
    21: "21st",
    22: "22nd",
    23: "23rd",
    31: "31st",
    "Last Day": "last",
  };

  const jobStatusOptions = [
    {
      value: "unscheduled",
      label: t("unscheduled"),
    },
    {
      value: "scheduled",
      label: t("scheduled"),
    },
  ];

  const parseInOrgTimezone = value =>
    value ? moment.utc(value).tz(orgTimezone) : null;

  // Load job details when component mounts
  useEffect(() => {
    if (
      selectedOrganization?.id &&
      isOpen &&
      selectedJob?.id &&
      selectedJob?.work_order?.id
    ) {
      getJobDetails({
        organization_id: selectedOrganization.id,
        workOrder_id: selectedJob?.work_order?.id,
        job_id: selectedJob?.id,
      });

      getOrganizationMembersShortList({
        organization_id: selectedOrganization.id,
      });

      // getTaskType({
      //   organization_id: selectedOrganization.id,
      // });

      getWorkOrderShortList({
        organization_id: selectedOrganization.id,
      });

      // Fetch locations for operation type on initial load
      if (orgType === "operation") {
        getOrganizationLocations({ organization_id: selectedOrganization.id });
      }

      if (selectedJob?.work_order?.id) {
        getTaskLocation({
          organization_id: selectedOrganization.id,
          client_id: selectedJob?.work_order?.id,
        });
      }

      let tempActiveMonthDates = {};
      for (let i = 1; i <= 31; i++) {
        tempActiveMonthDates[i] = false;
      }
      tempActiveMonthDates["Last Day"] = false;
      setActiveMonthDates(tempActiveMonthDates);

      let tempActiveMonthDays = {};
      for (let i = 0; i <= 27; i++) {
        tempActiveMonthDays[i] = false;
      }
      setActiveMonthDays(tempActiveMonthDays);
    }
  }, [selectedOrganization, isOpen, selectedJob]);

  // Service-specific initial fetches
  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      isOpen &&
      orgType === "service"
    ) {
      getClientShortList({ organization_id: selectedOrganization.id });
    }
  }, [selectedOrganization, isOpen, orgType]);

  // Ensure newly created customer shows up in the dropdown
  useEffect(() => {
    if (
      orgType === "service" &&
      selectedOrganization &&
      selectedOrganization.id &&
      createdClientId
    ) {
      getClientShortList({ organization_id: selectedOrganization.id });
    }
  }, [createdClientId, orgType, selectedOrganization]);

  // Select customer from clientShortList when it's loaded (for service type)
  useEffect(() => {
    if (
      orgType === "service" &&
      pendingClientId &&
      clientShortList &&
      clientShortList.length > 0 &&
      !selectedClient
    ) {
      const client = clientShortList.find(c => c.id === pendingClientId);
      if (client) {
        setSelectedClient({
          value: client.id,
          label: client.name,
        });
        setClientId(client.id);
        setCustomerName(client.name || "");
        setPendingClientId(null); // Clear pending ID after selection
      }
    }
  }, [clientShortList, pendingClientId, orgType, selectedClient]);

  // Populate form with job details when they are fetched
  useEffect(() => {
    // Prevent infinite loop by checking if jobDetails ID actually changed
    const currentJobDetailsId = jobDetails?.id;
    const prevJobDetailsId = prevJobDetailsIdRef.current;
    
    if (jobDetails && Object.keys(jobDetails).length > 0 && currentJobDetailsId !== prevJobDetailsId) {
      prevJobDetailsIdRef.current = currentJobDetailsId;
      // Reset lineItems initialization when jobDetails ID changes
      lineItemsInitializedRef.current = false;
      
      setJobName(jobDetails.name || "");
      setJobNumber(jobDetails.job_no || "");

      // Set job status
      const statusOption = jobStatusOptions.find(
        status => status.value === jobDetails.status,
      );
      if (statusOption) {
        setSelectedJobStatus(statusOption);
      }

      // Set schedule type based on status: "unscheduled" -> "later", else -> "now"
      if (jobDetails.status === "unscheduled") {
        setSelectedScheduleForType("later");
      } else {
        setSelectedScheduleForType("now");
      }

      setSelectedWorkOrder({
        value: jobDetails.work_order.id,
        label: jobDetails.work_order.name,
      });

      // Handle client differently for service vs operation type
      if (orgType === "service") {
        // For service type, client ID comes from work_order.client_id
        const clientIdFromWorkOrder = jobDetails?.work_order?.client_id;
        if (clientIdFromWorkOrder) {
          // Store the client ID to select after clientShortList is loaded
          setPendingClientId(clientIdFromWorkOrder);
          setClientId(clientIdFromWorkOrder);
          // Try to set customer name from work_order if available
          if (jobDetails?.work_order?.client_name) {
            setCustomerName(jobDetails.work_order.client_name);
          }
        }
        // Also check if client object exists (for backward compatibility)
        if (jobDetails.client) {
          setSelectedClient({
            value: jobDetails.client.id,
            label: jobDetails.client.name,
          });
          setClientId(jobDetails.client.id);
          setCustomerName(jobDetails.client.name || "");
          setPendingClientId(jobDetails.client.id);
        }
      } else {
        // For operation type, get client from work_order
        setClientId(jobDetails?.work_order?.client_id);
        setCustomerName(jobDetails?.work_order?.client_name || "");
        setSelectedClient(null);
      }

      if (jobDetails.description) {
        setTaskDescription(jobDetails.description);
      }

      if (jobDetails.location && jobDetails.location.id) {
        setAddLocationButton(true);
        // Store location ID to select after location list is loaded
        setPendingLocationId(jobDetails.location.id);
        // For service type, wait for location list to be loaded before selecting
        // For operation type, we can set it immediately if organizationLocationList is available
        if (orgType === "operation" && organizationLocationList?.length > 0) {
          const locationOption = buildLocationOption(jobDetails.location);
          updateSelectedLocationState(locationOption);
        } else if (orgType !== "service") {
          // For non-service types, set location immediately
          const locationOption = buildLocationOption(jobDetails.location);
          updateSelectedLocationState(locationOption);
        }
        // For service type, location will be selected when clientLocationList is loaded
      }

      // Set is_anytime
      setIsAnyTimeSet(jobDetails.is_anytime || false);

      // Set start date ONLY from required_start_date (independent of start_time)
      // if (jobDetails.required_start_date) {
      //   const parsedDate = parseInOrgTimezone(jobDetails.required_start_date);
      //   if (parsedDate) {
      //     setStartDate(parsedDate);
      //   }
      // } else 

      //set start date from start_time since we edit individual job
        if (jobDetails.start_time) {
        const parsedDate = parseInOrgTimezone(jobDetails.start_time);
        if (parsedDate) {
          setStartDate(parsedDate);
        }
      } else {
        // For unscheduled jobs, set startDate to current date as default
        setStartDate(moment().tz(orgTimezone));
      }

      // Set end date ONLY from required_end_date (for ALL jobs, not just recurring)
      if (jobDetails.required_end_date) {
        const parsedEndDate = parseInOrgTimezone(jobDetails.required_end_date);
        if (parsedEndDate) {
          setEndDate(parsedEndDate);
        }
      }

      // Set start_time and end_time independently (no relation to dates)
      if (jobDetails.start_time) {
        const startTimeMoment = parseInOrgTimezone(jobDetails.start_time);
        setStartTime(startTimeMoment ? startTimeMoment.format("HH:mm:ss") : "");
      }

      if (jobDetails.end_time) {
        const endTimeMoment = parseInOrgTimezone(jobDetails.end_time);
        setEndTime(endTimeMoment ? endTimeMoment.format("HH:mm:ss") : "");
      }

      if (jobDetails.assignees && jobDetails.assignees.length > 0) {
        let newAssignees = jobDetails.assignees.map(assignee => ({
          id: assignee.id,
          name: `${assignee.first_name} ${assignee.last_name}`,
          email: assignee.email,
          avatar: assignee?.avatar || "",
          color: assignee?.color || "",
          phone: assignee?.phone || "",
        }));
        setSelectedAssignees(newAssignees);
      }

      setThemeColor(jobDetails.theme_color || "#D2E4FE");

      // Initialize line items and documents for service type
      if (orgType === "service") {
        // For service type, subtasks are actually line items
        // Only set lineItems on initial load, not when they're being edited
        if (jobDetails.subtasks && Array.isArray(jobDetails.subtasks) && !lineItemsInitializedRef.current) {
          setLineItems(jobDetails.subtasks);
          lineItemsInitializedRef.current = true;
        }
        // Initialize documents from job_documents
        if (
          jobDetails.job_documents &&
          Array.isArray(jobDetails.job_documents)
        ) {
          setDocuments(jobDetails.job_documents);
        }
      }

      // Fetch subtasks when jobDetails are available (only for operation type)
      // For service type, subtasks (line items) come directly from jobDetails.subtasks
      if (
        orgType === "operation" &&
        selectedOrganization?.id &&
        jobDetails?.work_order?.id &&
        jobDetails?.id
      ) {
        getSubtasks({
          organization_id: selectedOrganization.id,
          work_order_id: jobDetails.work_order.id,
          job_id: jobDetails.id,
        });
      }

      // Handle recurring job data if present
      // Skip recurring data processing for unscheduled jobs
      if (jobDetails.status === "unscheduled") {
        setIsRecurringScheduleOpen(false);
      } else if (jobDetails.recurring) {
        setIsRecurringScheduleOpen(true);
        setInterval(parseInt(jobDetails.interval) || 1);

        // NOTE: endDate is already set above from required_end_date

        // Set recurring schedule type
        if (jobDetails.schedule_type === "daily") {
          setSelectedRecurringSchedule("daily");
        } else if (jobDetails.schedule_type === "weekly") {
          setSelectedRecurringSchedule("weekly");
          // Populate selectedRecurringScheduleDays for weekly
          if (jobDetails.days_of_week && jobDetails.days_of_week.length > 0) {
            const dayNames = jobDetails.days_of_week.map(dayIndex => {
              return FULL_WEEK_DAYS[dayIndex] || SHORT_WEEK_DAYS[dayIndex];
            });
            setSelectedRecurringScheduleDays(dayNames);
          }
        } else if (jobDetails.schedule_type === "monthly") {
          setSelectedRecurringSchedule("monthly");

          if (jobDetails.is_weekdays_of_month) {
            setMonthlyScheduleMode("days");
            // Populate activeMonthDays
            let tempActiveMonthDays = {};
            for (let i = 0; i <= 27; i++) {
              tempActiveMonthDays[i] = false;
            }
            if (jobDetails.weekdays_of_month) {
              jobDetails.weekdays_of_month.forEach(day => {
                tempActiveMonthDays[day] = true;
              });
            }
            setActiveMonthDays(tempActiveMonthDays);
          } else {
            setMonthlyScheduleMode("dates");
            // Populate activeMonthDates
            let tempActiveMonthDates = {};
            for (let i = 1; i <= 31; i++) {
              tempActiveMonthDates[i] = false;
            }
            tempActiveMonthDates["Last Day"] = false;
            if (jobDetails.days_of_month) {
              jobDetails.days_of_month.forEach(day => {
                tempActiveMonthDates[day] = true;
              });
            }
            if (jobDetails.is_last_day_month) {
              tempActiveMonthDates["Last Day"] = true;
            }
            setActiveMonthDates(tempActiveMonthDates);
          }
        }
      } else {
        setIsRecurringScheduleOpen(false);
      }
    }
  }, [jobDetails, orgTimezone]);

  useEffect(() => {
    // Prevent infinite loop by checking if subtasks actually changed
    const subtasksIdsString = subtasks?.map(s => s?.id).filter(Boolean).join(',') || '';
    const prevIdsString = prevSubtasksRef.current;
    
    if (subtasks && subtasksIdsString !== prevIdsString) {
      prevSubtasksRef.current = subtasksIdsString;
      
      if (orgType === "service") {
        const formattedLineItems = subtasks.map(subtask => ({
          id: subtask.id,
          subtaskId: subtask.id,
          name: subtask.name || "",
          itemType: subtask.item_type || "product",
          serial_number: subtask.serial_number || "",
          description: subtask.description || "",
          quantity: subtask.quantity || 1,
          unitPrice: subtask.unit_price || "0.00",
          unit_price: subtask.unit_price || "0.00",
          allow_evidences: subtask.allow_evidences || false,
          evidenceToggle: subtask.allow_evidences || false,
          amount: subtask.amount || "0.00",
          status: subtask.status || "to do",
        }));
        setLineItems(formattedLineItems);
      } else {
        const formattedSubtasks = subtasks.map(subtask => ({
          id: subtask.id,
          name: subtask.name || "",
          description: subtask.description || "",
          isAllowedEvidences: subtask.allow_evidences || false,
          serial_number: subtask.serial_number || null,
          is_active: subtask.is_active !== undefined ? subtask.is_active : true,
        }));
        setSubTaskList(formattedSubtasks);
      }
    } else if (!subtasks && prevIdsString !== null) {
      // Clear if subtasks become null/undefined
      prevSubtasksRef.current = null;
      if (orgType === "service") {
        setLineItems([]);
      } else {
        setSubTaskList([]);
      }
    }
  }, [subtasks, orgType]);

  useEffect(() => {
    // Refetch subtasks after create/update/delete operations
    // For operation type: refetch subtasks
    // For service type: refetch subtasks (which are line items)
    if (subtaskCreated || subtaskUpdated || subtaskDeleted) {
      if (
        selectedOrganization?.id &&
        jobDetails?.work_order?.id &&
        jobDetails?.id
      ) {
        getSubtasks({
          organization_id: selectedOrganization.id,
          work_order_id: jobDetails.work_order.id,
          job_id: jobDetails.id,
        });
      }
      resetSubtaskStatus();
    }
  }, [subtaskCreated, subtaskUpdated, subtaskDeleted, orgType]);

  // Sync job documents from store (edit mode)
  useEffect(() => {
    // Prevent infinite loop by checking if jobDocuments actually changed
    const jobDocumentsIdsString = jobDocuments?.map(d => d?.id).filter(Boolean).join(',') || '';
    const prevIdsString = prevJobDocumentsRef.current;
    
    if (
      orgType !== "operation" &&
      jobDocuments &&
      Array.isArray(jobDocuments) &&
      jobDocumentsIdsString !== prevIdsString
    ) {
      prevJobDocumentsRef.current = jobDocumentsIdsString;
      const formattedDocuments = jobDocuments.map(doc => ({
        id: doc.id,
        document: doc.document,
        description: doc.description || "",
        is_processed: doc.is_processed || false,
      }));
      setDocuments(formattedDocuments);
    } else if (!jobDocuments && prevIdsString !== null) {
      // Clear if jobDocuments becomes null/undefined
      prevJobDocumentsRef.current = null;
      setDocuments([]);
    }
  }, [jobDocuments, orgType]);

  // Refetch documents after successful upload
  useEffect(() => {
    if (
      documentDone &&
      !prevDocumentDoneRef.current &&
      selectedOrganization?.id &&
      jobDetails?.work_order?.id &&
      jobDetails?.id
    ) {
      // Only refetch when documentDone transitions from false to true
      prevDocumentDoneRef.current = true;
      getJobDocuments({
        organization_id: selectedOrganization.id,
        work_order_id: jobDetails.work_order.id,
        job_id: jobDetails.id,
      });
    } else if (!documentDone && prevDocumentDoneRef.current) {
      // Reset ref when documentDone becomes false (new upload started)
      prevDocumentDoneRef.current = false;
    }
  }, [documentDone, selectedOrganization?.id, jobDetails?.work_order?.id, jobDetails?.id, getJobDocuments]);

  // Fetch client locations for service type only
  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      clientId &&
      orgType !== "operation"
    ) {
      getClientLocation({
        organization_id: selectedOrganization.id,
        client_id: clientId,
      });
    }
  }, [clientId, orgType]);

  useEffect(() => {
    if (workOrderShortList && workOrderShortList.length > 0) {
      let newArr = [];
      workOrderShortList.forEach((workorder, i) => {
        newArr.push({
          label: workorder.name,
          value: workorder.id,
          client_id: workorder.client_id,
          client_name: workorder.client_name,
        });
      });
      setWorkOrderOptions(newArr);
    }
  }, [workOrderShortList]);

  // Handle client locations for service type
  useEffect(() => {
    // Prevent infinite loop by checking if clientLocationList actually changed
    const locationListIdsString = clientLocationList?.map(l => l?.id).filter(Boolean).join(',') || '';
    const prevIdsString = prevClientLocationListRef.current;
    
    if (orgType !== "operation" && clientLocationList && locationListIdsString !== prevIdsString) {
      prevClientLocationListRef.current = locationListIdsString;
      
      if (clientLocationList.length > 0) {
        const formattedOptions = clientLocationList
          .map(location => buildLocationOption(location))
          .filter(option => option && option.latitude && option.longitude);

        // Preserve location from jobDetails if it exists and isn't in the list
        let finalOptions = [...formattedOptions];
        if (selectedLocation && selectedLocation.value) {
          const locationExists = formattedOptions.some(
            option => option.value === selectedLocation.value,
          );
          if (!locationExists) {
            // Add the location from jobDetails to the options
            finalOptions.push(selectedLocation);
          }
        }

        setJobLocationOptions(finalOptions);

        // If we have a pending location ID from jobDetails, select it
        if (pendingLocationId) {
          const locationOption = finalOptions.find(
            option => option.value === pendingLocationId
          );
          if (locationOption) {
            updateSelectedLocationState(locationOption);
            setPendingLocationId(null); // Clear pending ID after selection
          } else {
            // If location not found in list, try to use default or first option
            const defaultOption =
              finalOptions.find(option => option.is_default === true) ||
              finalOptions[0];
            updateSelectedLocationState(defaultOption || null);
          }
        } else if (!selectedLocation) {
          // Only set default option if selectedLocation is not already set and no pending location
          const defaultOption =
            finalOptions.find(option => option.is_default === true) ||
            finalOptions[0];
          updateSelectedLocationState(defaultOption || null);
        }
        // If selectedLocation is already set (from jobDetails), don't overwrite it
      } else if (clientLocationList.length === 0) {
        // Only clear location if it wasn't set from jobDetails
        if (!selectedLocation && !pendingLocationId) {
          setJobLocationOptions([]);
          updateSelectedLocationState(null);
        } else if (pendingLocationId) {
          // If we have a pending location but list is empty, preserve it
          setJobLocationOptions([]);
        } else {
          // Preserve the location from jobDetails even if list is empty
          setJobLocationOptions([selectedLocation]);
        }
      }
    } else if (!clientLocationList && prevIdsString !== null) {
      // Clear if clientLocationList becomes null/undefined
      prevClientLocationListRef.current = null;
      setJobLocationOptions([]);
    }
  }, [clientLocationList, orgType, pendingLocationId]); // Removed selectedLocation to prevent infinite loop

  // Handle created client location for service type
  useEffect(() => {
    if (
      orgType !== "operation" &&
      createdClientLocationInfo &&
      createdClientLocationInfo.id
    ) {
      updateSelectedLocationState(
        buildLocationOption(createdClientLocationInfo),
      );
    }
  }, [createdClientLocationInfo, orgType]);

  // Handle created organization location for operation type
  useEffect(() => {
    if (
      orgType === "operation" &&
      createdOrgLocationInfo &&
      createdOrgLocationInfo.id
    ) {
      // Refresh organization locations list first to get updated list
      if (selectedOrganization && selectedOrganization.id) {
        getOrganizationLocations({
          organization_id: selectedOrganization.id,
        });
      }
      // Update selected location after a short delay to allow list to refresh
      setTimeout(() => {
        updateSelectedLocationState(
          buildLocationOption(createdOrgLocationInfo),
        );
      }, 300);
    }
  }, [createdOrgLocationInfo, orgType, selectedOrganization]);

  // Handle organization locations for operation type
  useEffect(() => {
    if (orgType === "operation" && organizationLocationList) {
      if (organizationLocationList.length > 0) {
        const formattedOptions = organizationLocationList
          .map(location => buildLocationOption(location))
          .filter(option => option && option.latitude && option.longitude);
        setJobLocationOptions(formattedOptions);
        if (
          !selectedLocation ||
          !formattedOptions.some(
            option => option.value === selectedLocation.value,
          )
        ) {
          const defaultOption =
            formattedOptions.find(option => option.is_default === true) ||
            formattedOptions[0];
          updateSelectedLocationState(defaultOption || null);
        }
      } else if (organizationLocationList.length === 0) {
        setJobLocationOptions([]);
        setSelectedLocation(null);
      }
    }
  }, [organizationLocationList, orgType]);

  useEffect(() => {
    if (!isOpen) {
      clearState();
      // Reset refs when popup closes
      prevJobDetailsIdRef.current = null;
      prevClientLocationListRef.current = null;
      lineItemsInitializedRef.current = false;
      prevSubtasksRef.current = null;
      prevJobDocumentsRef.current = null;
      prevDocumentDoneRef.current = false;
    }
  }, [isOpen]);

  // Close popup when job update is successful
  useEffect(() => {
    if (isSubmitted && jobUpdate && !createOrUpdateJobIsLoading && isOpen) {
      setIsSubmitted(false);
      if (onUpdateChange) {
        onUpdateChange(true); // Pass true to trigger refetch in parent
      }
      toggle();
    }
  }, [
    jobUpdate,
    isSubmitted,
    createOrUpdateJobIsLoading,
    isOpen,
    onUpdateChange,
    toggle,
  ]);

  const locationInputOpen = () => {
    setAddLocationButton(true);
  };

  const onTaskNameChange = e => {
    setJobName(e.target.value);
    if (saveErrors.name) {
      const errors = { ...saveErrors };
      delete errors.name;
      setSaveErrors(errors);
    }
  };

  const onJobNumberChange = e => {
    setJobNumber(e.target.value);
    if (saveErrors.jobNumber) {
      const errors = { ...saveErrors };
      delete errors.jobNumber;
      setSaveErrors(errors);
    }
  };

  const clearState = () => {
    setJobName("");
    setJobNumber("");
    setSelectedWorkOrder(null);
    setSelectedAssignees([]);
    setRequiresApproval(false);
    setTaskDescription("");
    setSelectedLocation(null);
    setJobLocationOptions([]);
    setStartDate(moment(new Date()));
    setStartTime("");
    setEndTime("");
    setInterval(1);
    setActiveDays({
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    });
    setActiveMonthDates({});
    setActiveMonthDays({});
    setEndDate(null);
    setSelectedJobStatus(null);
    setThemeColor("#D2E4FE");
    setSaveErrors({});
    setWorkOrderOptions([]);
    setClientId("");
    setSelectedClient(null);
    setCustomerName("");
    setLineItems([]);
    setDocuments([]);
    setIsClientModalOpen(false);
    setAddLocationButton(false);
    setEditType("single");
    setSubTaskList([]);
    setIsSubTaskModalOpen(false);
    setIsEditSubTaskModalOpen(false);
    setSelectedSubTaskId(null);
    setSelectedScheduleForType("now");
    setIsRecurringScheduleOpen(false);
    setSelectedRecurringSchedule("daily");
    setSelectedRecurringScheduleDays([]);
    setMonthlyScheduleMode("dates");
    setIsAnyTimeSet(false);
    setPendingClientId(null);
    setPendingLocationId(null);
  };
  const approvalToggle = () => {
    setRequiresApproval(!requiresApproval);
  };

  const handleAssignOrRemoveMember = (user, action) => {
    if (user && user.id) {
      let newArr = [...selectedAssignees];
      if (action === "remove") {
        newArr = newArr.filter(member => member.id !== user.id);
      } else {
        newArr.push(user);
      }
      setSelectedAssignees(newArr);
    }
  };

  const handleAssignMember = user => {
    handleAssignOrRemoveMember(user, "assign");
  };

  const handleRemoveMember = user => {
    handleAssignOrRemoveMember(user, "remove");
  };

  const onTaskDescriptionChange = e => {
    setTaskDescription(e.target.value);
    if (saveErrors.description) {
      const errors = { ...saveErrors };
      delete errors.description;
      setSaveErrors(errors);
    }
  };

  const onLocationChange = option => {
    updateSelectedLocationState(option);
  };

  const onWorkOrderChange = e => {
    setSelectedWorkOrder(e);

    // For operation type, customer/client is not required
    if (orgType === "operation") {
      setClientId("");
      setCustomerName("");
      // Don't clear location options - they're independent of work order
    } else {
      // For service type, set client/customer info
      setClientId(e.client_id);
      setCustomerName(e.client_name || e.client?.name || "");
      // Clear selected location when work order changes
      // This will trigger a fetch of new locations for the new client
      setSelectedLocation(null);
      setJobLocationOptions([]);
    }
  };

  const onDateChange = date => {
    if (isRecurringDisabled) return;
    setStartDate(date);
    setEndDate(null);
  };

  const onMonthDateSelect = date => {
    if (isRecurringDisabled) return;
    let errors = { ...saveErrors };
    delete errors["activeMonthDates"];
    setSaveErrors(errors);
    let tempActiveMonthDates = { ...activeMonthDates };
    tempActiveMonthDates[date] = !tempActiveMonthDates[date];
    setActiveMonthDates(tempActiveMonthDates);
  };

  const onMonthDaySelect = day => {
    if (isRecurringDisabled) return;
    let errors = { ...saveErrors };
    delete errors["activeMonthDays"];
    setSaveErrors(errors);
    let tempActiveMonthDays = { ...activeMonthDays };
    tempActiveMonthDays[day] = !tempActiveMonthDays[day];
    setActiveMonthDays(tempActiveMonthDays);
  };

  const findDateText = date => {
    if (dateText[date]) {
      return dateText[date];
    } else {
      return `${date}th`;
    }
  };

  const capitalizeSummary = text =>
    text ? text.charAt(0).toUpperCase() + text.slice(1) : "";

  const monthlyDatesSummary = useMemo(() => {
    const selectedDates = [];
    for (let i = 1; i <= MONTH_TOTAL_DAYS; i++) {
      if (activeMonthDates[i]) {
        selectedDates.push(findDateText(i));
      }
    }
    if (activeMonthDates["Last Day"]) {
      selectedDates.push("last day");
    }
    if (!selectedDates.length) {
      return "";
    }
    const intervalText =
      interval === 1 ? "each month" : `every ${interval} months`;
    if (selectedDates.length === 1) {
      return `${capitalizeSummary(selectedDates[0])} of ${intervalText}`;
    }
    const lastEntry = selectedDates.pop();
    return `${selectedDates.join(", ")} and ${lastEntry} of ${intervalText}`;
  }, [activeMonthDates, interval]);

  const monthlyDaysSummary = useMemo(() => {
    const selections = [];
    for (let weekIndex = 0; weekIndex < 4; weekIndex++) {
      for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
        const key = weekIndex * 7 + dayIndex;
        if (activeMonthDays[key]) {
          const weekLabel = findDateText(weekIndex + 1);
          const dayLabel = FULL_WEEK_DAYS[dayIndex];
          selections.push(`${weekLabel} ${dayLabel}`);
        }
      }
    }
    if (!selections.length) {
      return "";
    }
    const intervalText =
      interval === 1 ? "each month" : `every ${interval} months`;
    if (selections.length === 1) {
      return `${selections[0]} of ${intervalText}`;
    }
    const lastEntry = selections.pop();
    return `${selections.join(", ")} and ${lastEntry} of ${intervalText}`;
  }, [activeMonthDays, interval]);

  const onEndDateSelect = date => {
    if (isRecurringDisabled) return;
    let errors = { ...saveErrors };
    delete errors["endDate"];
    setSaveErrors(errors);
    setEndDate(date);
  };

  const onActiveDaysSelect = day => {
    let errors = { ...saveErrors };
    delete errors["activeDays"];
    setSaveErrors(errors);
    let tempActiveDays = { ...activeDays };
    tempActiveDays[day] = !tempActiveDays[day];
    setActiveDays(tempActiveDays);
  };

  const onIntervalChange = value => {
    if (isRecurringDisabled) return;
    let errors = { ...saveErrors };
    delete errors["interval"];
    setSaveErrors(errors);
    setInterval(parseInt(value));
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };

  const handleThemeColor = color => {
    setThemeColor(color);
  };

  const handleCancel = () => {
    toggle();
  };

  const handleStartTime = time => {
    if (time) {
      let errors = { ...saveErrors };
      delete errors["timeDifference"];
      setSaveErrors(errors);
      const start_time = time.replace(/ /g, "");
      setStartTime(moment(start_time, "h:mmA").format("HH:mm:ss"));
    } else {
      setStartTime("");
    }
  };
  const handleEndTime = time => {
    if (time) {
      let errors = { ...saveErrors };
      delete errors["timeDifference"];
      setSaveErrors(errors);
      const end_time = time.replace(/ /g, "");
      setEndTime(moment(end_time, "h:mmA").format("HH:mm:ss"));
    } else {
      setEndTime("");
    }
  };

  const handleAnytimeToggle = () => {
    setIsAnyTimeSet(prev => !prev);
    if (!isAnyTimeSet) {
      setSaveErrors(prevErrors => {
        const errors = { ...prevErrors };
        delete errors["timeDifference"];
        return errors;
      });
    }
  };

  const buildMomentWithTime = (timeValue, dateValue) => {
    if (!timeValue || !dateValue) {
      return null;
    }
    const formats = [
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DD HH:mm",
      "YYYY-MM-DD h:mmA",
      "YYYY-MM-DD h:mm A",
    ];
    const dateString = `${dateValue.format("YYYY-MM-DD")} ${timeValue}`;
    const parsed = moment(dateString, formats, true);
    return parsed.isValid() ? parsed : null;
  };

  const getJobDurationText = () => {
    if (!startDate || !startTime || !endTime || isAnyTimeSet) {
      return "-";
    }
    const startMomentFull = buildMomentWithTime(startTime, startDate);
    const endMomentFull = buildMomentWithTime(endTime, startDate);
    if (!startMomentFull || !endMomentFull) {
      return "-";
    }
    const diffInSeconds = endMomentFull.diff(startMomentFull, "seconds");
    if (diffInSeconds <= 0) {
      return "-";
    }
    return formatDurationToHoursMinutes(diffInSeconds);
  };

  const handleIntervalChange = e => {
    if (isRecurringDisabled) return;
    const { value } = e.target;
    if (value === "") {
      setInterval("");
      return;
    }
    const parsed = parseInt(value, 10);
    if (!isNaN(parsed) && parsed > 0) {
      setInterval(parsed);
      let errors = { ...saveErrors };
      delete errors["interval"];
      setSaveErrors(errors);
    }
  };

  const handleMonthlyIntervalChange = option => {
    if (isRecurringDisabled) return;
    setInterval(option ? option.value : 1);
    let errors = { ...saveErrors };
    delete errors["interval"];
    setSaveErrors(errors);
  };

  const monthlyIntervalOptions = [
    { label: "Every month", value: 1 },
    { label: "Every 2 months", value: 2 },
    { label: "Every 3 months", value: 3 },
    { label: "Every 6 months", value: 6 },
    { label: "Every 12 months", value: 12 },
  ];

  const renderRepeatIntervalInput = unit => {
    // Determine max value based on schedule type
    let maxValue;
    if (selectedRecurringSchedule === "daily") {
      maxValue = 150;
    } else if (selectedRecurringSchedule === "weekly") {
      maxValue = 25;
    } else {
      maxValue = undefined; // No max for other types
    }

    return (
      <CommonFlex
        alignItems="start"
        direction="column"
        gap="5px"
        margin="10px 0 0"
      >
        <CommonFlex style={{ width: "100%" }}>
          <CommonText>Repeat every</CommonText>
          <InputField
            type="number"
            min="1"
            max={maxValue}
            value={interval}
            onChange={handleIntervalChange}
            disabled={isRecurringDisabled}
            style={{
              maxWidth: "90px",
              textAlign: "center",
              border:
                saveErrors && saveErrors["interval"]
                  ? "1px solid #fe5969"
                  : undefined,
              backgroundColor:
                saveErrors && saveErrors["interval"]
                  ? "rgba(252, 87, 104, 0.05)"
                  : isRecurringDisabled
                  ? "#f5f5f5"
                  : undefined,
              cursor: isRecurringDisabled ? "not-allowed" : "text",
              opacity: isRecurringDisabled ? 0.6 : 1,
            }}
          />
          <CommonText>{unit}</CommonText>
        </CommonFlex>
        {saveErrors && saveErrors["interval"] && (
          <FormAlert style={{ marginBottom: 0 }}>
            {saveErrors["interval"]}
          </FormAlert>
        )}
      </CommonFlex>
    );
  };

  const renderMonthlyIntervalSelect = () => {
    const selectedOption =
      monthlyIntervalOptions.find(option => option.value === interval) ||
      monthlyIntervalOptions[0];

    return (
      <CommonFlex
        alignItems="center"
        justifyContent="flex-end"
        gap="10px"
        margin="0"
      >
        <Select
          value={selectedOption}
          options={monthlyIntervalOptions}
          onChange={handleMonthlyIntervalChange}
          isDisabled={isRecurringDisabled}
          styles={CreateProjectDropdown({
            error: saveErrors && saveErrors["interval"],
          })}
          filterOption={filterOption}
        />
        {saveErrors && saveErrors["interval"] && (
          <FormAlert style={{ marginBottom: 0 }}>
            {saveErrors["interval"]}
          </FormAlert>
        )}
      </CommonFlex>
    );
  };

  const onRecurringScheduleTypeChange = scheduleType => {
    if (isRecurringDisabled) return;
    setSelectedRecurringSchedule(scheduleType);
    let errors = { ...saveErrors };
    delete errors["selectedRecurringSchedule"];
    setSaveErrors(errors);
    // For monthly, ensure interval is one of the valid options (1, 2, 3, 6, 12), default to 1
    if (scheduleType === "monthly") {
      const validMonthlyIntervals = [1, 2, 3, 6, 12];
      if (!validMonthlyIntervals.includes(interval)) {
        setInterval(1);
      }
    }
  };

  const toggleRecurringWeekDay = day => {
    if (isRecurringDisabled) return;
    setSelectedRecurringScheduleDays(prev => {
      if (prev.includes(day)) {
        return prev.filter(item => item !== day);
      }
      return [...prev, day];
    });
    setSaveErrors(prevErrors => {
      const errors = { ...prevErrors };
      delete errors["selectedRecurringScheduleDay"];
      return errors;
    });
  };

  const onJobStatusChange = e => {
    setSelectedJobStatus(e);
  };

  const handleDisable = () => {
    let isValid = false;
    if (
      jobName.trim() &&
      selectedWorkOrder &&
      selectedWorkOrder.value &&
      selectedScheduleForType
      // Location is optional for operation type
      // For service type, location validation is handled in checkError
    ) {
      if (selectedScheduleForType === "later") {
        // For "later", assignees are optional
        isValid = true;
      } else if (selectedScheduleForType === "now") {
        // For "now", assignees are required
        if (selectedAssignees.length > 0) {
          if (!isRecurringScheduleOpen) {
            isValid = true;
          } else if (isRecurringScheduleOpen && endDate) {
            // Check recurring schedule validations
            if (selectedRecurringSchedule === "weekly") {
              // For weekly, at least one day must be selected
              isValid = selectedRecurringScheduleDays.length > 0;
            } else if (selectedRecurringSchedule === "monthly") {
              // For monthly, check if dates or days mode has selections
              if (monthlyScheduleMode === "dates") {
                const hasSelectedDates = Object.values(activeMonthDates).some(
                  val => val === true,
                );
                isValid = hasSelectedDates;
              } else if (monthlyScheduleMode === "days") {
                const hasSelectedDays = Object.values(activeMonthDays).some(
                  val => val === true,
                );
                isValid = hasSelectedDays;
              }
            } else if (selectedRecurringSchedule === "daily") {
              // Daily doesn't need additional selection
              isValid = true;
            }
          }
        }
      }
    }
    return !isValid;
  };

  const handleSave = () => {
    if (!createOrUpdateJobIsLoading && checkError() && checkPlan()) {
      if (
        selectedOrganization?.id &&
        selectedJob?.id &&
        selectedJob?.work_order?.id
      ) {
        let assigneeIds = [];
        if (selectedAssignees && selectedAssignees.length > 0) {
          selectedAssignees.forEach(element => {
            assigneeIds.push(element.id);
          });
        }
        let payload = {
          organization_id: selectedOrganization.id,
          name: jobName,
          workOrder_id: selectedWorkOrder.value,
          job_id: selectedJob.id,
          job_no: jobNumber,
          status:
            selectedScheduleForType === "now" ? "scheduled" : "unscheduled",
        };

        // Only include bulk field if job is recurring
        if (jobDetails?.recurring) {
          payload.bulk = editType === "future" ? true : false;
        }

        if (assigneeIds && assigneeIds.length > 0) {
          payload.assignees = assigneeIds;
        }

        if (taskDescription && taskDescription !== "") {
          payload.description = taskDescription;
        }

        if (themeColor) {
          payload.theme_color = themeColor;
        }

        if (selectedLocation && selectedLocation.value) {
          // const { value, label, ...rest } = selectedLocation;
          // payload.location_id = { id: value, name: label, ...rest };
          payload.location_id = selectedLocation.value;
        }

        if (selectedScheduleForType === "now") {
          // Format dates in organization timezone
          const startDateInTz = moment.tz(startDate, orgTimezone);
          payload.required_start_date = startDateInTz
            .format("YYYY-MM-DDTHH:mm:ss");

          // end_time should always be on the same day as start_time
          const endTimeDate = startDateInTz;

          // Add is_anytime boolean (matching API response format)
          payload.is_anytime = isAnyTimeSet;

          if (isAnyTimeSet) {
            // If anytime is true, set start_time to 00:00 and end_time to 23:59 in org timezone
            payload.start_time = moment
              .tz(
                startDateInTz.format("YYYY-MM-DD") + " 00:00",
                "YYYY-MM-DD HH:mm",
                orgTimezone,
              )
              .format("YYYY-MM-DDTHH:mm:ss");
            payload.end_time = moment
              .tz(
                endTimeDate.format("YYYY-MM-DD") + " 23:59",
                "YYYY-MM-DD HH:mm",
                orgTimezone,
              )
              .format("YYYY-MM-DDTHH:mm:ss");
          } else {
            // If anytime is false, use user-provided start_time and end_time
            if (startTime && endTime) {
              // Parse times in organization timezone
              payload.start_time = moment
                .tz(
                  startDateInTz.format("YYYY-MM-DD") + " " + startTime,
                  "YYYY-MM-DD HH:mm:ss",
                  orgTimezone,
                )
                .format("YYYY-MM-DDTHH:mm:ss");
              payload.end_time = moment
                .tz(
                  endTimeDate.format("YYYY-MM-DD") + " " + endTime,
                  "YYYY-MM-DD HH:mm:ss",
                  orgTimezone,
                )
                .format("YYYY-MM-DDTHH:mm:ss");
            } else {
              // Fallback if times are not provided (shouldn't happen due to validation)
              payload.start_time = moment
                .tz(
                  startDateInTz.format("YYYY-MM-DD") + " 00:00",
                  "YYYY-MM-DD HH:mm",
                  orgTimezone,
                )
                .format("YYYY-MM-DDTHH:mm:ss");
              payload.end_time = moment
                .tz(
                  endTimeDate.format("YYYY-MM-DD") + " 23:59",
                  "YYYY-MM-DD HH:mm",
                  orgTimezone,
                )
                .format("YYYY-MM-DDTHH:mm:ss");
            }
          }

          payload.recurring = isRecurringScheduleOpen;

          // Set required_end_date:
          // - If NOT recurring: same day as start date
          // - If recurring (daily/weekly/monthly): user must provide end date
          if (!isRecurringScheduleOpen) {
            payload.required_end_date = startDateInTz
              .endOf("day")
              .format("YYYY-MM-DDTHH:mm:ss");
          } else {
            payload.interval = parseInt(interval, 10) || 1;
            payload.schedule_type = selectedRecurringSchedule;
            const endDateInTz = moment.tz(endDate, orgTimezone);
            payload.required_end_date = endDateInTz
              .endOf("day")
              .format("YYYY-MM-DDTHH:mm:ss");
          }
          if (
            isRecurringScheduleOpen &&
            selectedRecurringSchedule === "weekly"
          ) {
            // Convert selectedRecurringScheduleDays (e.g., "Mon" or "Monday") to day index (0-6)
            if (selectedRecurringScheduleDays.length > 0) {
              const dayIndices = selectedRecurringScheduleDays
                .map(day => {
                  let dayIndex = SHORT_WEEK_DAYS.indexOf(day);
                  if (dayIndex === -1) {
                    dayIndex = FULL_WEEK_DAYS.indexOf(day);
                  }
                  return dayIndex;
                })
                .filter(index => index !== -1);
              if (dayIndices.length > 0) {
                payload.days_of_week = dayIndices;
              }
            }
          } else if (
            isRecurringScheduleOpen &&
            selectedRecurringSchedule === "monthly"
          ) {
            if (monthlyScheduleMode === "dates") {
              let tempMonthDatesArray = [];
              for (let i = 1; i <= 31; i++) {
                if (activeMonthDates[i]) {
                  tempMonthDatesArray.push(i);
                }
              }
              payload.days_of_month = tempMonthDatesArray;
              if (activeMonthDates["Last Day"]) {
                payload.is_last_day_month = true;
              }
              payload.is_weekdays_of_month = false;
            } else if (monthlyScheduleMode === "days") {
              let tempMonthDaysArray = [];
              for (let i = 0; i <= 27; i++) {
                if (activeMonthDays[i]) {
                  tempMonthDaysArray.push(i);
                }
              }
              payload.weekdays_of_month = tempMonthDaysArray;
              payload.is_weekdays_of_month = true;
            }
          }
        }
        // Service type: subtasks (line items) and documents are handled via separate API calls
        // No need to include them in the update payload
        updateJobRequest(payload);
        // console.log("Payload to update job:", payload);
        setIsSubmitted(true);
      }
    }
  };

  const checkPlan = () => {
    if (
      isRecurringScheduleOpen &&
      selectedOrganization &&
      selectedOrganization.plan &&
      selectedOrganization.plan.name === "Free"
    ) {
      setIsRecurringDisabled(true);
      toggle();
      pricingPopupToggle();
      return false;
    } else {
      return true;
    }
  };

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;
    if (!jobName.trim()) {
      formIsValid = false;
      saveErrors["jobName"] = t("job_name_is_required");
    } else if (checkUrl(jobName)) {
      formIsValid = false;
      saveErrors["jobName"] = t("job_name_can_not_contain_url");
    } else if (checkHtml(jobName)) {
      formIsValid = false;
      saveErrors["jobName"] = t("invalid_job_name");
    } else if (jobName.length > 255) {
      formIsValid = false;
      saveErrors["jobName"] = t("maximum_length_255_characters");
    }
    if (!selectedWorkOrder || !selectedWorkOrder.value) {
      formIsValid = false;
      saveErrors["selectedWorkOrder"] = t("work_order_is_required");
    }
    // Location is optional - remove this validation (matching CreateJobNew behavior)
    // if (!selectedLocation || !selectedLocation.value) {
    //   formIsValid = false;
    //   saveErrors["selectedLocation"] = t("location_is_required");
    // }
    // Assignees are only required when "now" is selected, not for "later"
    if (selectedScheduleForType === "now" && selectedAssignees.length === 0) {
      formIsValid = false;
      saveErrors["selectedAssignees"] = t("assignee_is_required");
    }
    if (checkUrl(taskDescription)) {
      formIsValid = false;
      saveErrors["taskDescription"] = t("job_description_can_not_contain_url");
    } else if (checkHtml(taskDescription)) {
      formIsValid = false;
      saveErrors["taskDescription"] = t("invalid_job_description");
    } else if (taskDescription.length > 512) {
      formIsValid = false;
      saveErrors["taskDescription"] = t("maximum_length_512_characters");
    }
    if (selectedScheduleForType === "now") {
      if (!startDate) {
        formIsValid = false;
      }
      if (!isAnyTimeSet && (!startTime || !endTime)) {
        formIsValid = false;
        saveErrors["timeDifference"] = t(
          "start_time_and_end_time_are_required",
        );
      }
      if (
        !isAnyTimeSet &&
        startTime &&
        endTime &&
        moment(startDate.format("YYYY-MM-DD") + " " + endTime).diff(
          moment(startDate.format("YYYY-MM-DD") + " " + startTime),
        ) < 1
      ) {
        formIsValid = false;
        saveErrors["timeDifference"] = t("end_time_must_be_after_start_time");
      } else if (
        !isAnyTimeSet &&
        startTime &&
        endTime &&
        moment(startDate.format("YYYY-MM-DD") + " " + endTime).diff(
          moment(startDate.format("YYYY-MM-DD") + " " + startTime),
        ) < 1800000
      ) {
        formIsValid = false;
        saveErrors["timeDifference"] = t(
          "minimum_30_minutes_time_difference_required",
        );
      }
      if (
        !isAnyTimeSet &&
        startTime &&
        moment(startDate.format("YYYY-MM-DD") + " " + startTime).diff(
          moment(),
        ) < 1
      ) {
        formIsValid = false;
        saveErrors["timeDifference"] = t("past_time_cant_be_set");
      }
      // Recurring schedule validations
      if (isRecurringScheduleOpen) {
        if (!endDate) {
          formIsValid = false;
          saveErrors["endDate"] = t(
            "end_date_is_required_for_recurring_schedule",
          );
        }
        if (!selectedRecurringSchedule) {
          formIsValid = false;
          saveErrors["selectedRecurringSchedule"] = t(
            "recurring_schedule_type_must_be_selected",
          );
        }
        if (!interval || parseInt(interval, 10) < 1) {
          formIsValid = false;
          saveErrors["interval"] = t("repeat_value_must_be_at_least_1");
        } else if (
          selectedRecurringSchedule === "daily" &&
          parseInt(interval, 10) > 150
        ) {
          formIsValid = false;
          saveErrors["interval"] =
            "Interval maximum limit is 150 for daily schedule";
        } else if (
          selectedRecurringSchedule === "weekly" &&
          parseInt(interval, 10) > 25
        ) {
          formIsValid = false;
          saveErrors["interval"] =
            "Interval maximum limit is 25 for weekly schedule";
        } else if (
          selectedRecurringSchedule === "monthly" &&
          parseInt(interval, 10) > 12
        ) {
          formIsValid = false;
          saveErrors["interval"] =
            "Interval maximum limit is 12 for monthly schedule";
        }
        if (selectedRecurringSchedule === "weekly") {
          if (!selectedRecurringScheduleDays.length) {
            formIsValid = false;
            saveErrors["selectedRecurringScheduleDay"] = t(
              "at_least_one_weekday_must_be_selected_for_weekly_schedule",
            );
          }
        }
        if (selectedRecurringSchedule === "monthly") {
          if (monthlyScheduleMode === "dates") {
            let hasSelectedDates = false;
            Object.keys(activeMonthDates).forEach(key => {
              if (activeMonthDates[key] === true) {
                hasSelectedDates = true;
              }
            });
            if (!hasSelectedDates) {
              formIsValid = false;
              saveErrors["activeMonthDates"] = t(
                "at_least_one_date_must_be_selected_for_monthly_schedule",
              );
            }
          } else if (monthlyScheduleMode === "days") {
            let hasSelectedDays = false;
            Object.keys(activeMonthDays).forEach(key => {
              if (activeMonthDays[key] === true) {
                hasSelectedDays = true;
              }
            });
            if (!hasSelectedDays) {
              formIsValid = false;
              saveErrors["activeMonthDays"] = t(
                "at_least_one_weekday_must_be_selected_for_monthly_schedule",
              );
            }
          }
        }
      }
    }
    setSaveErrors(saveErrors);
    return formIsValid;
  };

  // Theme color component
  const ThemeColorComp = ({ color }) => (
    <ThemeBox
      color={color}
      active={themeColor === color}
      onClick={() => handleThemeColor(color)}
    >
      {themeColor === color && <CommonImage src={tick} alt="" width="10px" />}
    </ThemeBox>
  );

  const themeColorOptions = [
    "#D2E4FE",
    "#FFF4DE",
    "#FEEED0",
    "#FFDCE5",
    "#C3ECE8",
    "#F4D0FD",
    "#DBFEDB",
    "#D0F0FD",
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ maxWidth: `900px`,zIndex:1100 }}>
      <ModalBody
        style={{
          padding: `25px`,
          minHeight: `800px`,
          display: `flex`,
          flexDirection: `column`,
          position: `relative`,
        }}
      >
        {getJobIsLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <ModalCrossIcon
              src={crossIcon}
              alt="close"
              onClick={() => handleCancel()}
            />
            {/* <PageTitle>{t("edit_job")}</PageTitle> */}
            {orgType === "operation" ? (
              <AddOrgLocationModal
                isOpen={popupOpen}
                toggle={popupToggle}
                organization_id={selectedOrganization?.id}
                addOrgLocation={createOrgLocation}
                addOrgLocationLoading={addOrgLocationLoading}
                createdOrgLocationInfo={createdOrgLocationInfo}
                selectedOrganization={selectedOrganization}
              />
            ) : clientId && selectedOrganization?.id ? (
              <AddLocationModal
                isOpen={popupOpen}
                toggle={popupToggle}
                addClientLocation={addClientLocation}
                addOrUpdateclientLocalMapLoading={
                  addOrUpdateclientLocalMapLoading
                }
                createdClientLocationInfo={createdClientLocationInfo}
                organization_id={selectedOrganization.id}
                client_id={clientId}
                action="add"
                selectedOrganization={selectedOrganization}
              />
            ) : null}
            {selectedOrganization &&
              selectedOrganization.id &&
              orgType === "service" && (
                <ClientModal
                  isOpen={isClientModalOpen}
                  toggle={toggleClientModal}
                  selectedOrganization={selectedOrganization}
                  createClient={createClient}
                  isClientLoading={isClientLoading}
                  createdClientId={createdClientId}
                  createdClientInfo={createdClientInfo}
                  setSelectedClient={handleClientChange}
                  addClientLocation={addClientLocation}
                  getClientLocation={getClientLocation}
                  addOrUpdateclientLocalMapLoading={
                    addOrUpdateclientLocalMapLoading
                  }
                  createdClientLocationInfo={createdClientLocationInfo}
                  clientLocationList={clientLocationList}
                  clientId={clientId}
                  orgType={orgType}
                />
              )}
            <Container padding="10px" gap="20px">
              <CommonText fontSize="16px" fontWeight="600">
                {addItemDetailsLabel}
              </CommonText>
              <CommonGrid columns="1fr">
                <JobInputSection
                  jobName={jobName}
                  jobNumber={jobNumber}
                  selectedWorkOrder={selectedWorkOrder}
                  workOrderOptions={workOrderOptions}
                  selectedClient={selectedClient}
                  clientOptions={clientOptions}
                  taskDescription={taskDescription}
                  onTaskNameChange={onTaskNameChange}
                  onJobNumberChange={onJobNumberChange}
                  onWorkOrderChange={onWorkOrderChange}
                  onTaskDescriptionChange={onTaskDescriptionChange}
                  handleProjectModalToggle={null}
                  onClientChange={handleClientChange}
                  onAddCustomer={toggleClientModal}
                  scrollName={scrollName}
                  scrollDescription={scrollDescription}
                  jobInputRef={jobInputRef}
                  orgType={orgType}
                  saveErrors={saveErrors}
                  mode="edit"
                />
                <CommonFlex
                  gap="6px"
                  disableResponsive
                  alignItems="none"
                  direction="column"
                  style={{ paddingRight: "16px" }}
                >
                  <CommonGrid margin="0 10px 0px 0">
                    <InputLabel>{t("location")} </InputLabel>
                    <CommonText
                      fontSize="13px"
                      color="#2266EF"
                      margin="0 0 0 0"
                      fontWeight="550"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        popupToggle();
                      }}
                    >
                      <ButtonIcon src={Plus} alt="" /> Add Location
                    </CommonText>
                  </CommonGrid>
                  <CommonCardContainer padding="24px">
                    {/* <CommonFlex direction="column" gap="12px" width="100%"> */}

                    <SingleLocationMap location={selectedLocation} />
                    <CommonGrid margin="10px 0 0 0" columns="1fr 200px">
                      <CommonText>{selectedLocation?.address}</CommonText>
                      <Select
                        isSearchable
                        value={selectedLocation}
                        options={jobLocationOptions}
                        placeholder={t("select_location")}
                        onChange={option => onLocationChange(option)}
                        styles={CreateProjectDropdown({
                          error: saveErrors && saveErrors["selectedLocation"],
                        })}
                        filterOption={filterOption}
                      />
                    </CommonGrid>
                    {saveErrors && saveErrors["selectedLocation"] && (
                      <FormAlert>{saveErrors["selectedLocation"]}</FormAlert>
                    )}

                    {/* </CommonFlex> */}
                  </CommonCardContainer>
                </CommonFlex>
              </CommonGrid>
              <HorizontalLineDivider margin="5px 0" />
              <CommonGrid disableResponsive columns="1fr">
                <div style={{ width: "50%" }}>
                  <AddMultipleMemberDropDownNew
                    isLoading={memberShortListIsLoading}
                    assigneesList={selectedAssignees}
                    membersList={orgMembersShortList}
                    handleAssign={handleAssignMember}
                    handleRemove={handleRemoveMember}
                    isRequired={selectedScheduleForType === "now"}
                    selectedOrganization={selectedOrganization}
                  />
                </div>
                <HorizontalLineDivider margin="5px 0" />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Only show "Choose Edit Type" if job is recurring */}
                  {jobDetails?.recurring && (
                    <CommonGrid gap="10px" columns="1fr">
                      <InputLabel>Choose Edit Type</InputLabel>
                      <CommonGrid
                        justifyContent="flex-start"
                        disableResponsive
                        gap="4px"
                        alignItem="center"
                        margin="0 0 10px 0"
                      >
                        <RoundTab
                          onClick={() => setEditType("single")}
                          selected={editType === "single"}
                          text={`Only This ${
                            orgType === "service" ? "Job" : "Task"
                          }`}
                        />
                        <RoundTab
                          onClick={() => setEditType("future")}
                          selected={editType === "future"}
                          text={`This and Future ${
                            orgType === "service" ? "Jobs" : "Tasks"
                          }`}
                        />
                      </CommonGrid>
                    </CommonGrid>
                  )}

                  <CommonGrid gap="20px" columns="1fr">
                    <CommonFlex
                      direction="column"
                      alignItems="start"
                      gap="10px"
                    >
                      <InputLabel>Schedule For</InputLabel>
                      <CommonGrid
                        justifyContent="flex-start"
                        disableResponsive
                        gap="4px"
                        alignItem="center"
                      >
                        <RoundTab
                          onClick={() => setSelectedScheduleForType("now")}
                          selected={selectedScheduleForType === "now"}
                          text="Now"
                        />
                        <RoundTab
                          onClick={() => {
                            if (jobDetails?.status !== "scheduled") {
                              setSelectedScheduleForType("later");
                            }
                          }}
                          selected={selectedScheduleForType === "later"}
                          text="Later"
                          disabled={jobDetails?.status === "scheduled"}
                          style={{
                            opacity:
                              jobDetails?.status === "scheduled" ? 0.5 : 1,
                            cursor:
                              jobDetails?.status === "scheduled"
                                ? "not-allowed"
                                : "pointer",
                            pointerEvents:
                              jobDetails?.status === "scheduled"
                                ? "none"
                                : "auto",
                          }}
                        />
                      </CommonGrid>
                    </CommonFlex>

                    {selectedScheduleForType === "now" && (
                      <JobStartTimeSection
                        setStartTime={handleStartTime}
                        setEndTime={handleEndTime}
                        startDate={startDate}
                        onDateChange={onDateChange}
                        isAnyTimeSet={isAnyTimeSet}
                        handleAnytimeToggle={handleAnytimeToggle}
                        startTime={startTime}
                        endTime={endTime}
                        saveErrors={saveErrors}
                        getJobDurationText={getJobDurationText}
                        scrollTime={scrollTime}
                        handleStartTime={handleStartTime}
                        handleEndTime={handleEndTime}
                        orgType={orgType}
                        isRecurringDisabled={isRecurringDisabled}
                      />
                    )}
                  </CommonGrid>
                </div>
              </CommonGrid>

              {!isRecurringScheduleOpen &&
                selectedScheduleForType !== "later" && (
                  <CommonGrid>
                    <BorderButtonWithIcon
                      onClick={() => {
                        setIsRecurringScheduleOpen(!isRecurringScheduleOpen);
                      }}
                    >
                      <ButtonIcon src={Plus} alt="" />
                      Recurring Schedule
                    </BorderButtonWithIcon>
                  </CommonGrid>
                )}

              {isRecurringScheduleOpen &&
                selectedScheduleForType !== "later" && (
                  <RecurringScheduleSection
                    isRecurringScheduleOpen={isRecurringScheduleOpen}
                    setIsRecurringScheduleOpen={setIsRecurringScheduleOpen}
                    selectedRecurringSchedule={selectedRecurringSchedule}
                    setSelectedRecurringSchedule={setSelectedRecurringSchedule}
                    selectedRecurringScheduleDays={
                      selectedRecurringScheduleDays
                    }
                    toggleRecurringWeekDay={toggleRecurringWeekDay}
                    monthlyScheduleMode={monthlyScheduleMode}
                    setMonthlyScheduleMode={setMonthlyScheduleMode}
                    interval={interval}
                    handleIntervalChange={handleIntervalChange}
                    handleMonthlyIntervalChange={handleMonthlyIntervalChange}
                    activeMonthDates={activeMonthDates}
                    onMonthDateSelect={onMonthDateSelect}
                    activeMonthDays={activeMonthDays}
                    onMonthDaySelect={onMonthDaySelect}
                    saveErrors={saveErrors}
                    endDate={endDate}
                    onEndDateSelect={onEndDateSelect}
                    startDate={startDate}
                    monthlyDatesSummary={monthlyDatesSummary}
                    monthlyDaysSummary={monthlyDaysSummary}
                    isRecurringDisabled={isRecurringDisabled}
                  />
                )}
            </Container>

            {orgType === "operation" && (
              <SubtaskSection
                subTaskList={subTaskList}
                setSubTaskList={setSubTaskList}
                setIsSubTaskModalOpen={setIsSubTaskModalOpen}
                openEditSubTaskModal={openEditSubTaskModal}
                onDeleteSubTask={handleDeleteSubtask}
              />
            )}
            {orgType !== "operation" && (
              <>
                <Container
                  style={{
                    marginTop: "10px",
                    marginRight: "10px",
                    marginLeft: "10px",
                    overflowX: "auto",
                  }}
                >
                  <LineItemSection
                    mode="edit"
                    lineItems={lineItems}
                    setLineItems={setLineItems}
                    onAddLineItem={handleAddLineItem}
                    onUpdateLineItem={handleUpdateLineItem}
                    onDeleteLineItem={handleDeleteLineItem}
                    currency={
                      selectedOrganization?.configuration?.currency || "USD"
                    }
                    pageName="other"
                  />
                </Container>
                <CommonCardContainer
                  bgColor="#EDF8FE"
                  style={{
                    marginTop: "20px",
                    marginRight: "10px",
                    marginLeft: "10px",
                  }}
                >
                  <DocumentUploadSection
                    mode="edit"
                    documents={documents}
                    setDocuments={setDocuments}
                    orgId={selectedOrganization?.id}
                    jobId={jobDetails?.id}
                    createJobDocument={createJobDocument}
                    deleteJobDocument={deleteJobDocument}
                    documentError={documentError}
                  />
                </CommonCardContainer>
              </>
            )}

            <AddSubTaskModal
              isOpen={isSubTaskModalOpen}
              toggle={() => setIsSubTaskModalOpen(!isSubTaskModalOpen)}
              onSubTaskAdd={newSubtask => {
                createSubtask({
                  organization_id: selectedOrganization.id,
                  work_order_id: jobDetails.work_order.id,
                  job_id: jobDetails.id,
                  data: newSubtask,
                  orgType: orgType,
                });
                setIsSubTaskModalOpen(false);
              }}
            />
            <EditSubTaskModal
              isOpen={isEditSubTaskModalOpen}
              toggle={closeEditSubTaskModal}
              onSubTaskUpdate={updatedSubtask => {
                updateSubtask({
                  organization_id: selectedOrganization.id,
                  work_order_id: jobDetails.work_order.id,
                  job_id: jobDetails.id,
                  subtask_id: selectedSubTaskId,
                  data: updatedSubtask,
                  orgType: orgType,
                });
                closeEditSubTaskModal();
              }}
              subTaskList={subTaskList}
              subTaskId={selectedSubTaskId}
            />

            <InputWithLabelSection style={{ margin: "16px 10px 10px 10px" }}>
              <CommonFlex gap="12px">
                <InfoTooltip
                  toolTipText="Select a theme color for the job to help visually distinguish it from others.."
                  mainText={t("choose_theme")}
                />
              </CommonFlex>

              <ThemesContainer>
                <ThemeColorComp color="#D4F4EE" />
                <ThemeColorComp color="#D2E4FE" />
                <ThemeColorComp color="#D9D7FC" />
                <ThemeColorComp color="#FDF3E4" />
              </ThemesContainer>
            </InputWithLabelSection>

            <CommonFlex
              justifyContent="flex-end"
              gap="10px"
              padding="0 11px"
              style={{ marginTop: `auto`, paddingTop: `20px` }}
            >
              <WhiteButton
                width="140px"
                type="cancel"
                onClick={() => handleCancel()}
              >
                {t("cancel")}
              </WhiteButton>
              <PrimaryButton
                disabled={handleDisable()}
                onClick={() => handleSave()}
                padding="0 25px"
                width="140px"
              >
                {createOrUpdateJobIsLoading ? (
                  <ButtonTextLoader
                    loadingText={t("updating")}
                    fontSize="13px"
                  />
                ) : (
                  t("update")
                )}
              </PrimaryButton>
            </CommonFlex>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default EditJobPopup;
